export const appName = "Pillars Speaker"

export function isEmailPrivileged(email: string | undefined | null): boolean {
  if (!email) return false
  const privilegedDomains = ["@thepillarsapp.com"]
  return privilegedDomains.some((domain) =>
    email.toLowerCase().includes(domain)
  )
}
